import { ReactNode } from 'react';
import { AlertTriangle } from 'lucide-react';

import Modal from '../modal/modal.component';

import styles from './warning-modal.module.scss';

interface Props {
    title: string;
    body: string;
    note?: string;
    extra?: ReactNode;
    checkbox?: {
        label: ReactNode;
        checked: boolean;
        onChange: (checked: boolean) => void;
    };
    onConfirm: () => void;
    onDiscard?: () => void;
    confirmText?: string;
    discardText?: string;
    confirmLoading?: boolean;
    confirmDisabled?: boolean;
    error?: string;
}

const WarningModal = ({
    title,
    body,
    note,
    extra,
    checkbox,
    onConfirm,
    onDiscard,
    confirmText,
    discardText,
    confirmLoading,
    confirmDisabled,
    error,
}: Props) => {
    return (
        <Modal
            onConfirm={onConfirm}
            onDiscard={onDiscard}
            confirmText={confirmText}
            discardText={discardText}
            confirmLoading={confirmLoading}
            confirmDisabled={confirmDisabled}
        >
            <div className={styles.wrapper}>
                <div className={styles.icon}>
                    <AlertTriangle size={28} />
                </div>
                <h4 className={styles.title}>{title}</h4>
                <p className={styles.body}>{body}</p>
                {note && <p className={styles.note}>{note}</p>}
                {extra}
                {checkbox && (
                    <label className={styles.checkboxRow}>
                        <input
                            type="checkbox"
                            checked={checkbox.checked}
                            onChange={(event) =>
                                checkbox.onChange(event.target.checked)
                            }
                        />
                        {checkbox.label}
                    </label>
                )}
                {error && <p className={styles.error}>{error}</p>}
            </div>
        </Modal>
    );
};

export default WarningModal;
